import BehaviorExpressionParser from './parsers/expression/behavior_expression_parser';
import BehaviorsEventsSubscriber from './parsers/event/behaviors_events_subscriber';
import BehaviorActionsExecutor from './parsers/action/behavior_actions_executor';
import FlashMessagesTypes from '../flash_message/constants/flash_messages_types';
import { FlashMessageAPI } from 'lecom-api';

import { FormAPI, ProcessAPI } from 'lecom-api';
import { getCookie } from '../utils/cookie_utils';

export const init = ({ formStoreId }) => {
	const formAPI = new FormAPI({ storeId: formStoreId });

	try {
		BehaviorsEventsSubscriber.subscribe(formAPI, executeBehaviorActionsOnCondition);
	}
	catch(err) {
		catchErrorBehaviorEngine(err);
	}
	return Promise.resolve();
};

const executeBehaviorActionsOnCondition = (formAPI, behavior, eventName) => {
	const { condition } = behavior;
	try{
		if(!condition || BehaviorExpressionParser.parse(formAPI, condition)) {
			BehaviorActionsExecutor.execute(formAPI, behavior, eventName, true);
		} else {
			BehaviorActionsExecutor.execute(formAPI, behavior, eventName, false);
		}
	}
	catch(err){
		catchErrorBehaviorEngine( err);
	}
};

function catchErrorBehaviorEngine(err) {
	const message = Realize.i18n.t(err.message) || err.message;
	if (ProcessAPI.currentProcess().isTestMode()) {
		FlashMessageAPI.flash().addMessage({
			type: FlashMessagesTypes.ERROR,
			message: Realize.i18n.t(err.message) || err.message
		});
	} else {
		console.warn(message);
	}
}

export default {
	init,
};
